import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#005f87",
        secondary: "#55A0B9",
        accent: "#afd7e1",
        error: "#dc0000",
        info: "#2196F3",
        success: "#0a9b00",
        warning: "#eb780a"
      }
    }
  }
});
